/**
 * Captures the values of query parameters in marked hidden inputs.
 */
export class CaptureQueries {
  /**
   * Initialize the capture mechanism.
   *
   * @param {Element} form - The associated form element.
   *
   * @constructor
   */
  constructor(form) {
    this.form = form;

    this.syncQueries();
  }

  /**
   * Transfers the values from the query parameters to the inputs.
   */
  syncQueries() {
    const inputs = [...this.form.querySelectorAll('input[data-capture-query]')];
    const parameters = {};

    new URLSearchParams(window.location.search).forEach((value, key) => {
      parameters[key] = value;
    });
    inputs.forEach((input) => {
      const source = input.dataset?.captureQuery;
      const value = source && parameters[source];

      input.value = value || '';
    });
  }
}
